import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_arrow_left.svg'
import _imports_1 from '@/app/ui/assets/svg/close-border-red.svg'
import _imports_2 from '@/app/ui/assets/svg/check-circle-border-green.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ef32b5a0")

_pushScopeId("data-v-ef32b5a0")
const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px h-screen" }
const _hoisted_2 = {
  class: "px-8 py-4 flex flex-col lg:flex-row justify-between lg:items-center gap-2 lg:gap-0",
  style: {"border-bottom":"1px solid rgba(224, 224, 224, 1)"}
}
const _hoisted_3 = { class: "flex flex-col md:flex-row flex-wrap lg:flex-nowrap text-12px xxl:text-14px items-start lg:items-center w-full md:w-auto" }
const _hoisted_4 = { class: "font-semibold text-20px whitespace-nowrap text-black-lp-100 capitalize h-auto w-full lg:w-auto" }
const _hoisted_5 = {
  key: 0,
  class: "h-full justify-center bg-gray-lp-1000"
}
const _hoisted_6 = {
  key: 1,
  class: "grid grid-cols-4 bg-gray-lp-1000 pt-4 pb-12 px-5 h-full w-full gap-x-2 overflow-scroll"
}
const _hoisted_7 = { class: "flex flex-col h-full bg-white rounded-xl col-span-3" }
const _hoisted_8 = { class: "flex flex-row justify-between px-6 py-4 items-center border-b border-gray-lp-1400" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-base text-gray-lp-800 font-semibold" }, " Nomor STT ", -1)
const _hoisted_11 = { class: "text-base text-red-lp-100 font-semibold" }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "grid grid-cols-2 px-6 py-4 gap-x-4 border-b border-gray-lp-1400" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col gap-y-1"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-medium text-base text-black-lp-100" }, "Merchant", -1)
const _hoisted_16 = { class: "flex flex-col border border-gray-lp-1400 rounded-lg p-4 h-full" }
const _hoisted_17 = { class: "mb-2 font-semibold text-base text-black-lp-100 overflow-ellipsis line-clamp-1" }
const _hoisted_18 = { class: "mb-1 text-base text-gray-lp-300" }
const _hoisted_19 = { class: "text-sm text-gray-lp-800 overflow-ellipsis break-words line-clamp-2" }
const _hoisted_20 = {
  key: 3,
  class: "flex flex-col gap-y-1"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-medium text-base text-black-lp-100" }, "Penerima", -1)
const _hoisted_22 = { class: "flex flex-col border border-gray-lp-1400 rounded-lg p-4 h-full" }
const _hoisted_23 = { class: "mb-2 font-semibold text-base text-black-lp-100 overflow-ellipsis line-clamp-1" }
const _hoisted_24 = { class: "mb-1 text-base text-gray-lp-300" }
const _hoisted_25 = { class: "text-sm text-gray-lp-800 overflow-ellipsis break-words line-clamp-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_27 = { class: "flex flex-col py-2.5 px-6 border-b border-dashed border-gray-lp-1400" }
const _hoisted_28 = { class: "flex flex-row mb-4 pl-2.5 py-4 bg-gray-lp-2200 rounded-xl" }
const _hoisted_29 = { class: "flex flex-row w-1/2" }
const _hoisted_30 = {
  key: 1,
  class: "font-medium text-sm text-gray-lp-300 mr-4"
}
const _hoisted_31 = {
  key: 3,
  class: "font-medium text-sm text-gray-lp-300 w-full"
}
const _hoisted_32 = { class: "grid grid-cols-3 pl-18 w-1/2" }
const _hoisted_33 = {
  key: 1,
  class: "font-medium text-sm text-gray-lp-300 pl-6"
}
const _hoisted_34 = {
  key: 3,
  class: "font-medium text-sm text-gray-lp-300 pl-6"
}
const _hoisted_35 = {
  key: 5,
  class: "font-medium text-sm text-gray-lp-300 pl-6"
}
const _hoisted_36 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_37 = { class: "border-b py-2 border-gray-lp-1400" }
const _hoisted_38 = { class: "flex flex-row pl-2.5 items-center" }
const _hoisted_39 = { class: "flex flex-row w-1/2 items-center" }
const _hoisted_40 = { class: "grid grid-cols-3 pl-18 w-1/2" }
const _hoisted_41 = { class: "py-2" }
const _hoisted_42 = { class: "flex flex-row pl-2.5 items-center" }
const _hoisted_43 = { class: "flex flex-row w-1/2 items-center" }
const _hoisted_44 = { class: "grid grid-cols-3 pl-18 w-1/2" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "flex flex-row pl-2.5 items-center" }
const _hoisted_47 = { class: "flex flex-row w-1/2 items-center" }
const _hoisted_48 = { class: "font-medium text-sm text-gray-lp-300 w-2 mr-4 text-center" }
const _hoisted_49 = { class: "flex flex-row w-full" }
const _hoisted_50 = { class: "font-bold text-sm text-gray-lp-300 overflow-ellipsis line-clamp-1 self-center" }
const _hoisted_51 = { class: "grid grid-cols-3 pl-18 w-1/2" }
const _hoisted_52 = { class: "font-medium text-sm text-gray-lp-300 pl-6" }
const _hoisted_53 = { class: "font-medium text-sm text-gray-lp-300 pl-6" }
const _hoisted_54 = { class: "font-medium text-sm text-gray-lp-300 pl-6" }
const _hoisted_55 = { class: "flex flex-row px-6 py-4 gap-x-16 border-b border-gray-lp-1400 justify-end font-semibold" }
const _hoisted_56 = {
  key: 1,
  class: "flex flex-col justify-end gap-y-1 "
}
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-300 text-right" }, "Total kuantitas", -1)
const _hoisted_58 = { class: "text-base text-red-lp-100 text-right" }
const _hoisted_59 = {
  key: 3,
  class: "flex flex-col justify-end gap-y-1 "
}
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-300 text-right" }, "Total harga", -1)
const _hoisted_61 = { class: "text-base text-red-lp-100 text-right" }
const _hoisted_62 = { class: "px-6 py-3" }
const _hoisted_63 = {
  key: 1,
  class: "text-lg text-gray-lp-2300 font-medium mb-6"
}
const _hoisted_64 = {
  key: 2,
  class: "w-full gap-y-1 flex flex-col",
  style: {"margin-bottom":"6px"}
}
const _hoisted_65 = { key: 3 }
const _hoisted_66 = { class: "flex flex-row" }
const _hoisted_67 = { class: "flex flex-col mr-4" }
const _hoisted_68 = {
  key: 0,
  src: _imports_1,
  alt: "close-border-red"
}
const _hoisted_69 = {
  key: 1,
  src: _imports_2,
  alt: "check-circle-border-green"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("div", {
  class: "h-6 self-center rounded-xl",
  style: {"width":"1px","background-color":"#D9D9D9","margin-top":"6px"}
}, null, -1)
const _hoisted_71 = { class: "flex flex-col gap-y-2" }
const _hoisted_72 = { class: "text-gray-lp-2300 text-sm" }
const _hoisted_73 = { class: "text-gray-lp-2400 text-sm font-medium" }
const _hoisted_74 = {
  class: "flex flex-col bg-white rounded-xl col-span-1",
  style: {"height":"max-content"}
}
const _hoisted_75 = {
  key: 0,
  class: "py-5 px-4 border-b border-gray-lp-1400 w-full"
}
const _hoisted_76 = {
  key: 1,
  class: "py-5 px-4 border-b border-gray-lp-1400 text-base font-bold text-gray-lp-300"
}
const _hoisted_77 = { class: "flex flex-col p-4 gap-y-3" }
const _hoisted_78 = {
  width: "38",
  height: "40",
  viewBox: "0 0 38 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "absolute top-0 right-0"
}
const _hoisted_79 = {
  key: 3,
  class: "flex flex-col gap-y-1"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600" }, "Tanggal pesanan dibuat", -1)
const _hoisted_81 = { class: "font-bold text-base text-gray-lp-300" }
const _hoisted_82 = {
  key: 5,
  class: "flex flex-col gap-y-1"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "font-medium text-sm text-gray-lp-600" }, "Tanggal diperbarui", -1)
const _hoisted_84 = { class: "font-bold text-base text-gray-lp-300" }
const _hoisted_85 = {
  key: 7,
  class: "flex flex-col"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalSuccessProcessOrder = _resolveComponent("ModalSuccessProcessOrder")!
  const _component_ModalProcessKulioner = _resolveComponent("ModalProcessKulioner")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-6 mr-1 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_4, " Order ID " + _toDisplayString(_ctx.detailData.koOrderId), 1)
        ])
      ]),
      (_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_EmptyList, {
              "button-action": _ctx.buttonActionError,
              onAction: _ctx.getDetail,
              icon: _ctx.errorData.icon,
              customHeaderMessage: _ctx.errorData.header,
              customMessage: _ctx.errorData.message,
              customClassImage: "w-44"
            }, null, 8, ["button-action", "onAction", "icon", "customHeaderMessage", "customMessage"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "2.75rem",
                      width: "8.5rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.detailData.koOrderSttNo || "-"), 1)
                    ])),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 2,
                      height: "1.3rem",
                      width: "6.25rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode("img", {
                        src: require(`@/app/ui/assets/svg/product-logo/${_ctx.detailData.koProductType.toLowerCase()}-active.svg`),
                        class: "w-100px h-12"
                      }, null, 8, ["src"])
                    ]))
              ]),
              _createVNode("div", _hoisted_13, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "9.3rem",
                      width: "100%"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.detailData.koMerchantName), 1),
                        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.detailData.koMerchantPhoneNumber), 1),
                        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.detailData.koMerchantAddress), 1)
                      ])
                    ])),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 2,
                      height: "9.3rem",
                      width: "100%"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", _hoisted_23, _toDisplayString(_ctx.detailData.koRecipientName), 1),
                        _createVNode("div", _hoisted_24, _toDisplayString(_ctx.censorPhoneLastFour(_ctx.detailData.koRecipientPhoneNumber)), 1),
                        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.detailData.koRecipientAddress), 1)
                      ])
                    ])),
                _hoisted_26
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 0,
                          height: "1rem",
                          width: "1.875rem"
                        }))
                      : (_openBlock(), _createBlock("div", _hoisted_30, "No.")),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 2,
                          height: "1rem",
                          width: "20.25rem"
                        }))
                      : (_openBlock(), _createBlock("div", _hoisted_31, "Produk"))
                  ]),
                  _createVNode("div", _hoisted_32, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 0,
                          height: "1rem",
                          width: "5.25rem"
                        }))
                      : (_openBlock(), _createBlock("div", _hoisted_33, "Kuantitas")),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 2,
                          height: "1rem",
                          width: "5.25rem"
                        }))
                      : (_openBlock(), _createBlock("div", _hoisted_34, "Satuan")),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 4,
                          height: "1rem",
                          width: "5.25rem"
                        }))
                      : (_openBlock(), _createBlock("div", _hoisted_35, "Subtotal"))
                  ])
                ]),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock("div", _hoisted_36, [
                      _createVNode("div", _hoisted_37, [
                        _createVNode("div", _hoisted_38, [
                          _createVNode("div", _hoisted_39, [
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "1.875rem",
                              class: "mr-4"
                            }),
                            _createVNode(_component_Skeleton, {
                              height: "2.5rem",
                              width: "20.25rem"
                            })
                          ]),
                          _createVNode("div", _hoisted_40, [
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "5.25rem",
                              class: "pl-6"
                            }),
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "5.25rem",
                              class: "pl-6"
                            }),
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "5.25rem",
                              class: "pl-6"
                            })
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_41, [
                        _createVNode("div", _hoisted_42, [
                          _createVNode("div", _hoisted_43, [
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "1.875rem",
                              class: "mr-4"
                            }),
                            _createVNode(_component_Skeleton, {
                              height: "2.5rem",
                              width: "20.25rem"
                            })
                          ]),
                          _createVNode("div", _hoisted_44, [
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "5.25rem",
                              class: "pl-6"
                            }),
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "5.25rem",
                              class: "pl-6"
                            }),
                            _createVNode(_component_Skeleton, {
                              height: "1rem",
                              width: "5.25rem",
                              class: "pl-6"
                            })
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_45, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.koProduct, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: ["py-2", `${_ctx.detailData.koProduct.length === index + 1 ? 'border-b-0' : 'border-b border-gray-lp-1400'}`],
                          key: index
                        }, [
                          _createVNode("div", _hoisted_46, [
                            _createVNode("div", _hoisted_47, [
                              _createVNode("div", _hoisted_48, _toDisplayString(index + 1), 1),
                              _createVNode("div", _hoisted_49, [
                                _createVNode("img", {
                                  src: item.kodProductThumbnail,
                                  class: "rounded-lg w-10 h-10 mr-4"
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_50, _toDisplayString(item.kodProductName), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_51, [
                              _createVNode("div", _hoisted_52, _toDisplayString(item.kodQuantity), 1),
                              _createVNode("div", _hoisted_53, _toDisplayString(_ctx.formatPriceRP(item.kodPrice)), 1),
                              _createVNode("div", _hoisted_54, _toDisplayString(_ctx.formatPriceRP(item.kodTotalPrice)), 1)
                            ])
                          ])
                        ], 2))
                      }), 128))
                    ]))
              ]),
              _createVNode("div", _hoisted_55, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "2.6rem",
                      width: "6.5rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode("div", _hoisted_58, _toDisplayString(_ctx.detailData.koTotalQuantity), 1)
                    ])),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 2,
                      height: "2.6rem",
                      width: "6.5rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_59, [
                      _hoisted_60,
                      _createVNode("div", _hoisted_61, _toDisplayString(_ctx.formatPriceRP(_ctx.detailData.koTotalPrice)), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_62, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "1.5rem",
                      width: "100%",
                      class: "mb-6"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_63, "Aktivitas pesanan")),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock("div", _hoisted_64, [
                      _createVNode(_component_Skeleton, {
                        height: "3.375rem",
                        width: "100%"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "3.375rem",
                        width: "100%"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "3.375rem",
                        width: "100%"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "3.375rem",
                        width: "100%"
                      }),
                      _createVNode(_component_Skeleton, {
                        height: "3.375rem",
                        width: "100%"
                      })
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_65, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredHistorries, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          style: {"margin-bottom":"6px"}
                        }, [
                          _createVNode("div", _hoisted_66, [
                            _createVNode("div", _hoisted_67, [
                              (item.kohStatus.toLowerCase() === 'cncwrf')
                                ? (_openBlock(), _createBlock("img", _hoisted_68))
                                : (_openBlock(), _createBlock("img", _hoisted_69)),
                              _hoisted_70
                            ]),
                            _createVNode("div", _hoisted_71, [
                              _createVNode("div", _hoisted_72, _toDisplayString(_ctx.mapUpdateStatusLabel(item.kohStatus)), 1),
                              _createVNode("div", _hoisted_73, _toDisplayString(_ctx.formatDateNormal(new Date(item.kohCreatedAt), "DD MMMM YYYY, HH:mm")), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_74, [
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_75, [
                    _createVNode(_component_Skeleton, {
                      height: "1.3rem",
                      width: "6.25rem"
                    })
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_76, " Detail status ")),
              _createVNode("div", _hoisted_77, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "3.5rem",
                      width: "100%"
                    }))
                  : (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: ["flex flex-col px-4 py-2 rounded-lg border gap-y-1 relative", `${_ctx.deliveryStatusStyling.background}`]
                    }, [
                      _createVNode("div", {
                        class: ["font-medium text-sm", `${_ctx.deliveryStatusStyling.label}`]
                      }, " Status pesanan ", 2),
                      _createVNode("div", {
                        class: ["font-bold text-base", `${_ctx.deliveryStatusStyling.value}`]
                      }, _toDisplayString(_ctx.mapDeliveryStatusLabel(_ctx.detailData.koStatus)), 3),
                      (_openBlock(), _createBlock("svg", _hoisted_78, [
                        _createVNode("circle", {
                          cx: "29.8691",
                          cy: "8.86885",
                          r: "22.0673",
                          fill: _ctx.deliveryStatusBackgroundColor.top,
                          "fill-opacity": "0.09"
                        }, null, 8, ["fill"]),
                        _createVNode("circle", {
                          cx: "30.0635",
                          cy: "9.0636",
                          r: "30",
                          fill: _ctx.deliveryStatusBackgroundColor.bottom,
                          "fill-opacity": "0.08"
                        }, null, 8, ["fill"])
                      ]))
                    ], 2)),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 2,
                      height: "2.5rem",
                      width: "11.25rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_79, [
                      _hoisted_80,
                      _createVNode("div", _hoisted_81, _toDisplayString(_ctx.formatDateNormal(new Date(_ctx.detailData.koCreatedAt), "DD MMMM YYYY, HH:mm")), 1)
                    ])),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 4,
                      height: "2.5rem",
                      width: "11.25rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_82, [
                      _hoisted_83,
                      _createVNode("div", _hoisted_84, _toDisplayString(_ctx.formatDateNormal(new Date(_ctx.detailData.koUpdatedAt), "DD MMMM YYYY, HH:mm")), 1)
                    ])),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 6,
                      height: "2.5rem",
                      width: "11.25rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_85, [
                      (!_ctx.buttonTitle && _ctx.detailData.koOrderSttNo)
                        ? (_openBlock(), _createBlock(_component_LpButton, {
                            key: 0,
                            id: "button_print_receipt_detail_kulioner",
                            title: "Print resi",
                            color: "white",
                            textColor: "gray-lp-300",
                            textSize: "14",
                            iconGroupHoverColor: "gray-lp-300",
                            iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
                            customClass: "underline",
                            iconLeft: "printer-black",
                            sizeIcon: "24px",
                            small: "",
                            fontWeight: "semibold",
                            disabled: _ctx.isLoadingPrintReceipt,
                            onClick: _cache[2] || (_cache[2] = () => _ctx.onPrintReceipt(_ctx.detailData.koOrderSttNo))
                          }, null, 8, ["iconColor", "disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_LpButton, {
                        id: "button_download_order_detail_kulioner",
                        class: "mb-2",
                        title: "Download pesanan",
                        color: "white",
                        textColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
                        iconGroupHoverColor: "gray-lp-300",
                        customClass: "underline",
                        iconLeft: "download-new",
                        iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
                        sizeIcon: "18px",
                        iconV2: "",
                        textSize: "14",
                        small: "",
                        fontWeight: "semibold",
                        disabled: _ctx.isLoadingDownloadOrder,
                        onClick: _ctx.onDownloadOrder
                      }, null, 8, ["textColor", "iconColor", "disabled", "onClick"]),
                      _withDirectives(_createVNode(_component_LpButton, {
                        id: _ctx.buttonId,
                        title: _ctx.buttonTitle,
                        textColor: "white",
                        fontWeight: "semibold",
                        isWidthFull: true,
                        disabled: _ctx.isLoadingSubmitBtn,
                        onClick: _ctx.onButtonClick
                      }, null, 8, ["id", "title", "disabled", "onClick"]), [
                        [_vShow, _ctx.buttonTitle]
                      ])
                    ]))
              ])
            ])
          ]))
    ]),
    _createVNode(_component_ModalSuccessProcessOrder, {
      key: _ctx.successProcessResponse.sttId,
      modelValue: _ctx.isShowSuccessProcessModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowSuccessProcessModal = $event)),
      messageData: _ctx.successProcessResponse,
      productType: _ctx.detailData.koProductType,
      onClose: _ctx.getDetail
    }, null, 8, ["modelValue", "messageData", "productType", "onClose"]),
    _createVNode(_component_ModalProcessKulioner, {
      id: "modal-confirm-accept-order",
      modelValue: _ctx.isShowModalProcessKulioner,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModalProcessKulioner = $event)),
      data: [_ctx.detailData],
      onSuccess: _ctx.onSuccess,
      onFailed: _ctx.onFailed,
      onRefetch: _ctx.closeModalSuccess
    }, null, 8, ["modelValue", "data", "onSuccess", "onFailed", "onRefetch"])
  ], 64))
})